(() => {
  'use strict';
  const syncGroup = (group) => {
    if (!group) return;
    const target = group.querySelector('[data-wh-selected-option-value]');
    if (!target) return;
    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked) {
      const label = group.querySelector(`label[for="${CSS.escape(checked.id)}"]`);
      target.textContent = label?.dataset.whDisplayLabel || checked.value;
      return;
    }
    const select = group.querySelector('select');
    if (select) target.textContent = select.options[select.selectedIndex]?.textContent?.trim() || select.value;
  };
  const syncAll = (scope = document) => scope.querySelectorAll('.wh-variant-group').forEach(syncGroup);
  document.addEventListener('change', (event) => {
    const group = event.target.closest('.wh-variant-group');
    if (!group) return;
    requestAnimationFrame(() => syncGroup(group));
  });
  const recoverInitialSoldOutSelection = () => {
    document.querySelectorAll('variant-selects[data-wh-product-available="true"][data-wh-current-available="false"]').forEach((picker) => {
      const fallbackId = picker.dataset.whFirstAvailableVariant;
      if (!fallbackId) return;
      const url = new URL(window.location.href);
      if (url.searchParams.get('variant') === fallbackId) return;
      const recoveryKey = `wh-v132-stock-recovery:${url.pathname}:${url.searchParams.get('variant') || 'none'}`;
      try {
        if (sessionStorage.getItem(recoveryKey)) return;
        sessionStorage.setItem(recoveryKey, '1');
      } catch (_) {}
      url.searchParams.set('variant', fallbackId);
      window.location.replace(url.toString());
    });
  };
  document.addEventListener('DOMContentLoaded', () => { syncAll(); recoverInitialSoldOutSelection(); });
  document.addEventListener('shopify:section:load', (event) => syncAll(event.target));
})();
